import React, { useState, useEffect } from 'react'

import Select from "react-select";
import { useSelector } from 'react-redux';
import { personRoleNameLovSelector } from 'stores/redux/slice/personRoleSetup';

const all = { label: 'All', value: '' }

function PersonRoleNameLov({ name, label, gridController }) {
  const personRoleName = useSelector(personRoleNameLovSelector)
  const [selectedValue, setSelectedValue] = useState(all);

  useEffect(() => {
    const isValueInOptions = personRoleName.some(
      (option) => option.value === selectedValue?.value
    );
    if (!isValueInOptions && selectedValue) {
      setSelectedValue(all);
      gridController.current.filterExternally({
        personRoleName: ''
      });
    }
  }, [selectedValue, personRoleName, gridController]);

  return (
    <>
      <label htmlFor={`filter-${name}`} className="invisible">
        {label}
      </label>
      <Select
        value={selectedValue}
        className="grid-reactSelect-wrapper"
        classNamePrefix="grid-reactSelect"
        id={`filter-id-${name}`}
        inputId={`filter-${name}`}
        data-id={`filter-${name}`}
        options={[all, ...personRoleName]}
        name={name}
        defaultValue={all}
        menuPosition="absolute"
        menuPortalTarget={document.body}
        classNames={{
          option: () => `menu-item-${name}`

        }}

        onChange={(option) => {
          setSelectedValue(option);
          gridController.current.filterExternally({
            personRoleName: option?.value
          });
        }}
        styles={{ menuPortal: (base) => ({ ...base, minWidth: "10rem", zIndex: 999 }) }}
      />
    </>

  )
}

export default PersonRoleNameLov
